<template>
  <div class="vx-row">
    <vx-card titleIcon="FilterIcon" ref="filterCard" title="Advanced Filters" class="mb-8 user-list-filters"
               :collapse-action="true">
        <div class="vx-row">
          <div class="w-full vx-col md:w-1/3 sm:w-1/2">
            <label class="text-sm opacity-100 text-bold">General Search</label>
            <vs-input type="text" v-model="filters['search']" class="w-full mb-4 md:mb-0"/>
          </div>
          <div class="w-full vx-col md:w-1/3 sm:w-1/2">
            <label class="text-sm opacity-100 text-bold">Status</label>
            <v-select name="status" v-model="filters['status']" label="label"
                  :options="statusList" :reduce="option => option.value"   class="w-full"/>
          </div>
        </div>
        <div class="mt-5 vx-row">
          <div class="w-full ml-auto vx-col">
            <vs-button class="float-right mr-4" size="small"
                       color="danger" type="border" icon-pack="feather" v-on:click="filters={}">CLEAR
            </vs-button>
          </div>
        </div>
      </vx-card>

      <vx-card title="TENANT LIST" v-can:any="['view-tenant', 'create-tenant']">
        <template slot="actions">
          <div class="flex float-right">
            <div class="con-btns-user flex items-center justify-between">
              <div class="flex mb-4">
                <vs-button  v-can="'create-tenant'" @click="onClickCreateTenant" class="mr-4" color="primary" type="filled">Create Tenant</vs-button>
                <vs-button v-can="'view-tenant'" @click="onClickRefresh" class="mr-0" color="success" type="border"
                           icon-pack="feather" icon="icon-rotate-cw"></vs-button>
              </div>
            </div>
          </div>
        </template>
        <div slot="no-body" class="mt-4">
          <vs-table :max-items="(meta.per_page) ? meta.per_page : 10" id="tenants-table"
                    :data="tenants_list"  @sort="handleSort"  :sst="true" stripe
                    class="table-dark-inverted table-auto vs-con-loading__container">>

            <template slot="thead">
              <vs-th width="10%">CLIENT BUSINESS NAME</vs-th>
              <vs-th width="10%">ACCOUNT OWNER</vs-th>
              <vs-th width="15%">DOMAIN</vs-th>
              <vs-th width="10%">EMAIL</vs-th>
              <vs-th width="10%">STATUS</vs-th>
              <vs-th width="10%">CREATED BY</vs-th>
              <vs-th width="10%">SETUP DATE</vs-th>
<!--              <vs-th width="10%">GoCardless ID</vs-th>-->
              <vs-th width="15%">ACTION</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :state="tr.domain === MASTER_TENANT_DOMAIN ? 'warning' : ''" 
                class="cursor-pointer" 
                @click.native="onClickTenantView(data[indextr].id, data[indextr].status)"  
                :key="indextr" v-for="(tr, indextr) in data"
                :class="tr.domain === MASTER_TENANT_DOMAIN ? 'italic' : ''"
              >

                <vs-td :data="data[indextr].name">
                  <span class="text-primary"> {{ data[indextr].name }} <br> {{ data[indextr].account_number }}</span>
                </vs-td>

                <vs-td :data="data[indextr].first_name">
                  {{ data[indextr].first_name }} {{ data[indextr].last_name }}
                </vs-td>

                <vs-td :data="data[indextr].name">
                  {{ data[indextr].domain }}
                </vs-td>

                <vs-td :data="data[indextr].email">
                  {{ data[indextr].email }}
                </vs-td>

                <vs-td :data="data[indextr].status">
                  {{ data[indextr].status }}
                </vs-td>

                <vs-td :data="data[indextr].created_by">
                  {{ data[indextr].created_by}}
                </vs-td>

                <vs-td :data="data[indextr].created_at">
                  {{ __dateTimeFormatterToDate(data[indextr].created_at) }}
                </vs-td>

<!--                <vs-td :data="data[indextr].gocardless_id">-->

<!--                  <span v-if="data[indextr].gocardless_id.length > 0">-->
<!--                    {{ data[indextr].gocardless_id || 'N/A' }}-->
<!--                  </span>-->

<!--                  <vx-tooltip v-else class="mr-2" text="Create GoCardless customer" position="left">-->
<!--                    <vs-button @click.stop="onClickSyncCustomer(data[indextr])"-->
<!--                               size="small" color="danger" type="border" icon-pack="feather" icon="icon-refresh-cw">-->
<!--                    </vs-button>-->
<!--                  </vx-tooltip>-->

<!--                </vs-td>-->

                <vs-td>
                  <div class="vx-row">
                    <vx-tooltip v-can="'deploy-tenant'" class="mr-2" text="Deploy Tenant" position="top" v-if="['Not Deployed'].includes(data[indextr].status)">
                      <vs-button @click.stop="onClickDeployTenant(data[indextr].id)"
                                 size="small" color="success" type="border" icon-pack="feather" icon="icon-fast-forward"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip v-can="'edit-tenant'" class="mr-2" text="View/Update" position="top" v-if="['Pending Verification', 'Active', 'In-Active'].includes(data[indextr].status)">
                      <vs-button @click.stop="onClickTenantView(data[indextr].id, data[indextr].status)"
                                 size="small" color="warning" type="border" icon-pack="feather" icon="icon-eye"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip v-can="'delete-tenant'" class="mr-2" :text="`Delete ${data[indextr].name}`" position="top" v-if="['Pending Verification', 'Active', 'Not Deployed', 'In-Active'].includes(data[indextr].status) && data[indextr].domain !== MASTER_TENANT_DOMAIN">
                      <vs-button @click.stop="onClickDeleteTenantConfirmation(data[indextr])"
                                 size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip v-can="'suspend-tenant'" class="mr-2" :text="data[indextr].status === 'Active' ? `Suspend ${data[indextr].name}` : `Activate ${data[indextr].name}`" position="top" v-if="['Active', 'In-Active'].includes(data[indextr].status) && data[indextr].domain !== MASTER_TENANT_DOMAIN">
                      <vs-button @click.stop="onClickStatusChangeTenantConfirmation(data[indextr])"
                                 size="small" :color="data[indextr].status === 'Active' ? 'danger' : 'success'" type="border" icon-pack="feather" 
                                 :icon="data[indextr].status === 'Active' ? 'icon-x' : 'icon-check'"></vs-button>
                    </vx-tooltip>
                    <vx-tooltip class="mr-2" :text="`Navigate to ${data[indextr].name}`" position="top" v-if="['Pending Verification', 'Active', 'In-Active'].includes(data[indextr].status)">
                      <vs-button @click.stop="onClickNavigateToTenant(data[indextr].domain)"
                                 size="small" color="success" type="border" icon-pack="feather" icon="icon-navigation">
                        Navigate
                      </vs-button>
                    </vx-tooltip>
                    <vx-tooltip class="mr-2" text="Restore tenent" position="top" v-if="['Deleted'].includes(data[indextr].status)">
                      <vs-button @click.stop="onClickRestoreTenantConfirmation(data[indextr])"
                                 size="small" color="warning" type="border" icon-pack="feather" icon="icon-refresh-ccw">
                                 Restore
                      </vs-button>
                    </vx-tooltip>
                    <span class="mt-1 ml-1 font-bold italic" v-if="tr.domain === MASTER_TENANT_DOMAIN">DATA MASTER</span>
                  </div>
                </vs-td>
              </vs-tr>
            </template>


          </vs-table>
          <vs-pagination v-on:changeMaxItems="changePage" :size-array="meta.total ? meta.total : 20"
              :max-items="perPage" description-body="Rows per page" description-connector="of" description-title="Records"
              description :description-items="descriptionItems" :total="(meta.last_page) ? meta.last_page : 0"
              v-model="page" class="p-5">
          </vs-pagination>

        </div>
      </vx-card>
    <create-tenant-pop-up ref="createTenantPopUp"/>
    <update-tenant-pop-up ref="updateTenantPopUp"/>
    <vs-prompt
      :title="`Delete tenant '${delete_obj.suggest_name}' ?`"
      color="danger"
      :is-valid="validNameForDelete"
      acceptText="Delete tenant"
      @cancel="delete_obj.name=''"
      @accept="onClickRemoveTenant"
      :active.sync="activeDeletePrompt">
      <div class="con-exemple-prompt">
        <span>To confirm deletion, enter the name of the tenant in the text input field</span>
      <vs-input placeholder="name" vs-placeholder="name" v-model="delete_obj.name" class="mt-3 w-full" />
      </div>
    </vs-prompt>
    <vs-prompt
      :title="`Restore tenant '${restore_obj.name}' ?`"
      color="warning"
      acceptText="Restore tenant"
      @cancel="restore_obj={}"
      @accept="onClickRestoreTenant"
      :active.sync="activeRestorePrompt">
    </vs-prompt>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
import Filter from '@/mixins/filter';
import vSelect from 'vue-select'
import CreateTenantPopUp from "@/components/popups/tenants/CreateTenantPopUp";
import UpdateTenantPopUp from "@/components/popups/tenants/UpdateTenantPopUp";
const TenantRepository = RepositoryFactory.get('tenant')
const CustomerRepository = RepositoryFactory.get('customer')
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'
import { defaultPagination, perPageList, MASTER_TENANT_DOMAIN, APP_LEVEL_2_URL } from "@/constants/config";

export default {
  name: 'TenantList',
  data () {
    return {
      tenants_list: [],
      filters: {},
      page: 1,
      total: 0,
      meta: {},
      sort: '',
      perPage: defaultPagination,
      descriptionItems: perPageList,
      delete_obj: {
        name: '',
        id: '',
        suggest_name: ''
      },
      restore_obj: {},
      activeRestorePrompt:false,
      activeDeletePrompt: false,
      MASTER_TENANT_DOMAIN: MASTER_TENANT_DOMAIN,
      statusList: [
        { label: "Active", value: "Active" },
        { label: "Pending Verification", value: "Pending Verification" },
        { label: "Inactive", value: "In-Active" },
        { label: "Not Deployed", value: "Not Deployed" },
        { label: "Build In Progress", value: "Build In Progress" },
        { label: "Build Complete", value: "Build Complete" },
        { label: "Build Failed", value: "Build Failed" },
        { label: "Deleted", value: "Deleted" },
      ],
    }
  },
  components: {
    CreateTenantPopUp,
    UpdateTenantPopUp,
    'v-select': vSelect,
  },
  methods: {
    async refreshData () {
      await this.fetchTenants()
    },
    async onClickTenantUpdate (id) {
      await this.$refs.updateTenantPopUp.openPopup(id)
    },
    async onClickTenantView (id, status) {
      if(status === 'Deleted') {
        return 
      } 
      await this.$router.push({path: `/pages/tenants/${id}`})
    },
    onClickNavigateToTenant(domain) {
      window.open(`https://${domain}.${APP_LEVEL_2_URL}/`, '_blank');
    },
    async onClickDeployTenant(tenant_id) {
      await this.$vs.loading({
        container: '#tenants-table',
        scale: 0.50
      });
      try {
        await TenantRepository.deployTenant(tenant_id)
        await this.fetchTenants()
      } catch (error) {
        
      } finally {
        await this.$vs.loading.close('#tenants-table > .con-vs-loading')
      }
    },
    async onClickSyncCustomer(item) {
      this.$vs.loading();
      try {
        const payload = {
          tenant_id: item.id,
          params: {
            address_line1: "10 Richard Street",
            address_line2: "Marlow Road",
            address_line3: "",
            city: "Reading",
            company_name: "Sainsbury",
            country_code: "GB",
            email: item.email,
            postal_code: "RG16 7QW"
          }
        }
        await CustomerRepository.createCustomer(payload)
        this.showSuccessMessage('New go cardless customer created')
        await this.refreshData()
      }catch (error) {
        this.$vs.loading.close()
        this.convertAndNotifyError(error)
      }
      this.$vs.loading.close()
    },
    async fetchTenants() {
      await this.$vs.loading({
        container: '#tenants-table',
        scale: 0.50
      });
      try {
        const {data} = await TenantRepository.get(this.page, this.filterQuery, this.perPage, this.sort)
        this.tenants_list =  data.data
        this.meta = data.meta
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      await this.$vs.loading.close('#tenants-table > .con-vs-loading')
    },
    onClickDeleteTenantConfirmation(data) {
      this.delete_obj.id = data.id
      this.delete_obj.name = '',
      this.delete_obj.suggest_name = data.name
      this.activeDeletePrompt = true
    },
    async onClickRemoveTenant() {
      await this.$vs.loading({
        container: '#tenants-table',
        scale: 0.50
      });
      try {
        await TenantRepository.deleteTenant(this.delete_obj.id, { name: this.delete_obj.name })
        await this.fetchTenants()
      } catch (error) {
        this.convertAndNotifyError(error)
      }
      await this.$vs.loading.close('#tenants-table > .con-vs-loading')
    },
    domainSplitter(domain) {
      return domain.split('.')[0]
    },
    async onClickCreateTenant () {
      await this.$refs.createTenantPopUp.openPopup()
    },
    async onClickRefresh() {
      await this.fetchTenants()
    },
    async onClickStatusChangeTenantConfirmation(data) {
      try {
        await this.$vs.loading({
          container: '#tenants-table',
          scale: 0.50
        });
        let status = data.status === 'Active' ? 'in-active' : 'active'
        await TenantRepository.tenantStatusChange(status, data.id)
        await this.fetchTenants()
      } catch (error) {
        this.convertAndNotifyError(error)
      } finally {
        await this.$vs.loading.close('#tenants-table > .con-vs-loading')
      }
    },
    onClickRestoreTenantConfirmation(data){
      this.restore_obj = data
      this.activeRestorePrompt = true
    },
    async onClickRestoreTenant(){
      try{
      await this.$vs.loading({
          container: '#tenants-table',
          scale: 0.50
        });
      await TenantRepository.restoreTenant(this.restore_obj.id)
      await this.fetchTenants()
      }catch(error){
        this.convertAndNotifyError(error)
      }finally {
        this.restore_obj = {}
        await this.$vs.loading.close('#tenants-table > .con-vs-loading')
      }
    },
    filterQueryUpdate (){
      this.page = 1
      this.fetchTenants()
    },
    handleChangePage(page) {
      this.page=page;
      this.fetchTenants()
    },
    handleSort(key, active) {
      if(key){
        active = (active==='desc')? "-":'';
        this.sort=active+key;
        this.fetchTenants()
      }
    },
    changePage(index) {
      this.perPage = this.descriptionItems[index]
    },
  },
  watch : {
    page(){
      this.fetchTenants()
    },
    perPage() {
      this.fetchTenants()
    }
  },
  computed: {
    validNameForDelete() {
      return this.delete_obj.name === this.delete_obj.suggest_name
    }
  },
  mixins: [SuccessMessage, ErrorMessages, Filter],
}
</script>


<style scoped>

</style>
